import { render, staticRenderFns } from "./TitleTransferScreen.vue?vue&type=template&id=123f0786&"
import script from "./TitleTransferScreen.vue?vue&type=script&lang=js&"
export * from "./TitleTransferScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports